type ClassValue = string | false | null | undefined;

/**
 * Joins the truthy class names into a single `className` string.
 *
 * @example joinClassNames(styles.sidebar, isDemo && styles.sidebarWithDemoBanner)
 */
const joinClassNames = (...classNames: ClassValue[]): string => classNames.filter(Boolean).join(' ');

export default joinClassNames;
